import { render, staticRenderFns } from "./ListRegionais.vue?vue&type=template&id=334df5cf&scoped=true"
import script from "./ListRegionais.vue?vue&type=script&lang=js"
export * from "./ListRegionais.vue?vue&type=script&lang=js"
import style0 from "./ListRegionais.vue?vue&type=style&index=0&id=334df5cf&prod&lang=scss"
import style1 from "./ListRegionais.vue?vue&type=style&index=1&id=334df5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334df5cf",
  null
  
)

export default component.exports